// extracted by mini-css-extract-plugin
module.exports = {"todos":"Todos_todos__2s1OT"};